module.exports = __webpack_public_path__ + "img/toast-info.de0c0a4a.svg";